import { is_valid_reason } from '../required_reason_textarea/reason_rules';
import { upload_care_screenshot, save_care_request } from './care_request_api';
import { build_create_payload, validate_care_draft } from './care_request_rules';
import { api_error_message } from '../../../utils/api_error_message';


export const STAGE_UPLOAD = 'UPLOAD';
export const STAGE_CHANGE = 'CHANGE';

// A failure before the record step: UPLOAD = nothing changed; CHANGE = the swap was refused (screenshot_key is kept
// so a resubmit does not upload again).
export class TeacherChangeError extends Error {
  constructor(stage, cause, screenshot_key = '') {
    super(stage);
    this.stage = stage;
    this.cause = cause;
    this.screenshot_key = screenshot_key;
  }
}

// Field errors ({} = valid). The apis reason is also the record's note, so it needs 3+ characters.
export function validate_teacher_change({ teacher_uuid, reason, draft, now_ms }) {
  const errors = draft ? validate_care_draft(draft, { now_ms }) : {};
  if (!teacher_uuid) errors.teacher = 'Choose the new teacher.';
  if (!is_valid_reason(reason)) {
    errors.reason = 'An internal note (at least 3 characters) is required to change the teacher.';
  }
  return errors;
}

// The apis refusal text; the group route answers {reason: <error object or string>}.
export function swap_error_message(e) {
  return api_error_message(e);
}

// Screenshot first (a failed upload changes nothing), then the swap, then the record. Resolves {saved, payload, error}:
// saved=false means only the record failed, and Retry resends payload (same uuid, never saved twice).
export async function change_teacher_with_care(
  { session_uuid, teacher_uuid, note, draft, screenshot_key = '' },
  { swap, upload = upload_care_screenshot, save = save_care_request }
) {
  let key = screenshot_key;
  if (draft && draft.file && !key) {
    try {
      key = await upload(session_uuid, draft.file);
    } catch (e) {
      throw new TeacherChangeError(STAGE_UPLOAD, e);
    }
  }
  try {
    await swap();
  } catch (e) {
    throw new TeacherChangeError(STAGE_CHANGE, e, key);
  }
  if (!draft) return { saved: true, payload: null, error: null };
  const payload = build_create_payload(draft, {
    session_uuid,
    note,
    screenshot_key: key,
    expected_teacher_uuid: teacher_uuid
  });
  try {
    await save(payload);
    return { saved: true, payload, error: null };
  } catch (e) {
    return { saved: false, payload, error: e };
  }
}
